var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "@drklein/client-detection", "hypo_elements/Typescripts/Configuration/Configuration", "hypo_elements/Containers/Klappmodul/Klappmodul", "jquery"], function (require, exports, client_detection_1, Configuration_1, Klappmodul) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.initialize = exports.openTabByNameFromExternalTrigger = exports.openTabByName = exports.openTabFromExternalTrigger = exports.openTab = void 0;
    Klappmodul = __importStar(Klappmodul);
    var $reitermodule;
    var reitermodulSelector = ".reitermodul";
    var reitermodulThemedClass = "reitermodul-themed";
    var reitermodulIsHiddenOnTabletClass = "reitermodul--is-hiddenOnTablet";
    var tabsSelector = ".reitermodul_tabs";
    var tabContainerClass = "reitermodul_tabContainer";
    var tabHeadingClass = "reitermodul_tabHeading";
    var tabClass = "reitermodul_tab";
    var tabIsOpenClass = "reitermodul_tab--is-open";
    var reiterClass = "reiter";
    var reiterIsHiddenOnPhoneClass = "reiter--is-hiddenOnPhone";
    var reiterHeadClass = "reiter_head";
    var reiterBodyClass = "reiter_body";
    var klappmodulClass = "klappmodul";
    var klappmodulHeadClass = "klappmodul_head";
    var klappmodulBodyClass = "klappmodul_body";
    var reitermoduleTransformedToKlappmodule = false;
    function getSelectorFromClass(className) {
        return "." + className;
    }
    function getTabBody($tab) {
        return $($tab.children("a").attr("href") || "");
    }
    function hideTabBody($tabs) {
        $tabs.each(function (index, element) {
            var $tabBody = getTabBody($(element));
            $tabBody.hide();
            $tabBody.attr("aria-hidden", "true");
        });
    }
    function getReiterHeads($tabContent) {
        return $tabContent.children(getSelectorFromClass(reiterHeadClass));
    }
    function getTabHeading($tabContent) {
        var $tabHeading;
        $tabHeading = getReiterHeads($tabContent);
        return $tabHeading.text().trim();
    }
    function switchClasses($element, fromClass, toClass) {
        $element.removeClass(fromClass);
        $element.addClass(toClass);
    }
    function changeReitermodulToKlappmodul() {
        var $reitermodulContainer = $reitermodule.filter(getSelectorFromClass(reitermodulIsHiddenOnTabletClass))
            .children(getSelectorFromClass(tabContainerClass))
            .children();
        switchClasses($reitermodulContainer, reiterClass, klappmodulClass);
        addThemeClassToKlappmodul($reitermodulContainer);
        var $reitermodulHeads = $reitermodulContainer.children(getSelectorFromClass(reiterHeadClass));
        switchClasses($reitermodulHeads, reiterHeadClass, klappmodulHeadClass);
        var $reitermodulBodies = $reitermodulContainer.children(getSelectorFromClass(reiterBodyClass));
        switchClasses($reitermodulBodies, reiterBodyClass, klappmodulBodyClass);
        Klappmodul.initKlappmodule($reitermodulContainer);
        $reitermodulContainer.filter(getSelectorFromClass(reiterIsHiddenOnPhoneClass)).attr("style", "");
        $reitermodulContainer.not(getSelectorFromClass(reiterIsHiddenOnPhoneClass)).show();
        $reitermodulHeads.show();
        hideTabBody($reitermodulBodies);
        reitermoduleTransformedToKlappmodule = true;
    }
    function addThemeClassToKlappmodul($reitermodulContainer) {
        $($reitermodulContainer).each(function () {
            var theme = $(this).attr("data-theme");
            if (theme !== "default") {
                $(this).addClass("klappmodul-" + theme);
            }
        });
    }
    function changeKlappmodulToReitermodul() {
        var $reitermodulContainer = $reitermodule.children(getSelectorFromClass(tabContainerClass)).children();
        switchClasses($reitermodulContainer, klappmodulClass, reiterClass);
        var $klappmodulHeads = $reitermodulContainer.children(getSelectorFromClass(klappmodulHeadClass));
        switchClasses($klappmodulHeads, klappmodulHeadClass, reiterHeadClass);
        var $reitermodulBodies = $reitermodulContainer.children(getSelectorFromClass(klappmodulBodyClass));
        switchClasses($reitermodulBodies, klappmodulBodyClass, reiterBodyClass);
        closeTabs($(getSelectorFromClass(tabClass)).not(":first-child"));
        openTabInternally($(getSelectorFromClass(tabClass)).filter(":first-child"));
        $reitermodulContainer.not(":first-child").hide();
        $reitermodulContainer.filter(":first-child").show();
        var $reiterBodies = $reitermodulContainer.children(getSelectorFromClass(reiterBodyClass));
        $reiterBodies.show();
        $klappmodulHeads.hide();
        reitermoduleTransformedToKlappmodule = false;
    }
    function matchMediaListener(mediaQuery) {
        if (mediaQuery.matches) {
            changeReitermodulToKlappmodul();
        }
        else {
            changeKlappmodulToReitermodul();
        }
    }
    function createTab(index, $element) {
        var $tabContent = $element;
        var tabId = "#" + $tabContent.attr("id");
        var link = $("<a></a>")
            .attr("role", "tab")
            .attr("aria-controls", "section" + (index + 1))
            .attr("href", tabId);
        link.append($("<span></span>")
            .addClass(tabHeadingClass)
            .attr("data-hide-label-on-phone", getReiterHeads($tabContent).data("hide-label-on-phone"))
            .text(getTabHeading($tabContent)));
        var $tab = $("<li></li>")
            .addClass(tabClass)
            .attr("role", "presentation");
        $tab.append(link);
        $tab.attr("data-tab-for", tabId);
        if (index === 0) {
            $tab.addClass(tabIsOpenClass)
                .attr("aria-selected", "true");
        }
        return $tab;
    }
    function closeTabs($tabs) {
        $tabs.each(function (index, element) {
            var $tab = $(element);
            $tab.removeClass(tabIsOpenClass)
                .attr("aria-selected", "false");
            hideTabBody($tab);
        });
    }
    function openTabInternally($tab) {
        $tab.addClass(tabIsOpenClass)
            .attr("aria-selected", "true");
        var $tabBody = getTabBody($tab);
        $tabBody.fadeIn();
        $tabBody.attr("aria-hidden", "false");
    }
    function openTab($tab) {
        if (reitermoduleTransformedToKlappmodule) {
            Klappmodul.openKlappmodul($tab.closest(reitermodulSelector).find($tab.data("tab-for")));
        }
        else {
            closeTabs($tab.siblings());
            openTabInternally($tab);
        }
    }
    exports.openTab = openTab;
    function openTabFromExternalTrigger($tab) {
        if (reitermoduleTransformedToKlappmodule) {
            Klappmodul.openKlappmodulFromExternalTrigger($tab.closest(reitermodulSelector).find($tab.data("tab-for")));
        }
        else {
            closeTabs($tab.siblings());
            openTabInternally($tab);
        }
    }
    exports.openTabFromExternalTrigger = openTabFromExternalTrigger;
    function openTabByName(tabName) {
        var $reitermodul = $(reitermodulSelector);
        var $tabs = $reitermodul.find(".reitermodul_tab");
        $tabs.filter("[data-tab-for='" + tabName + "']").each(function (index, element) {
            openTab($(element));
        });
    }
    exports.openTabByName = openTabByName;
    function openTabByNameFromExternalTrigger(tabName) {
        var $reitermodul = $(reitermodulSelector);
        var $tabs = $reitermodul.find(".reitermodul_tab");
        $tabs.filter("[data-tab-for='" + tabName + "']").each(function (index, element) {
            openTabFromExternalTrigger($(element));
        });
    }
    exports.openTabByNameFromExternalTrigger = openTabByNameFromExternalTrigger;
    function createTabs() {
        $reitermodule.each(function (index, element) {
            var $reitermodul = $(element);
            if ($reitermodul.data("initialized")) {
                return;
            }
            var $tabs = $reitermodul.children(tabsSelector);
            $reitermodul.children(getSelectorFromClass(tabContainerClass)).children().each(function (index, element) {
                var $reiter = $(element);
                var $tab = createTab(index, $reiter);
                $tabs.append($tab);
                var tabTheme = $reiter.attr("data-theme");
                if (tabTheme) {
                    // AP: AZURE-15760: Tab module always changes to folding module
                    // AP: Quick solution, as this function will also be replaced soon => AZURE-13411
                    // $reitermodul.removeClass(reitermodulIsHiddenOnTabletClass);
                    $tab.addClass(tabClass + "-" + tabTheme);
                    if (tabTheme !== "default") {
                        $reitermodul.addClass(reitermodulThemedClass);
                    }
                }
            });
            $reitermodul.data("initialized", true);
        });
    }
    function addClickHandler() {
        $(getSelectorFromClass(tabClass)).each(function (index, element) {
            var $tabElement = $(element);
            $tabElement
                .off("click")
                .on("click", function (event) {
                var $tab = $tabElement;
                closeTabs($tab.siblings());
                openTabInternally($tab);
                // prevent link follow
                event.preventDefault();
            });
        });
    }
    function initialize() {
        $reitermodule = $(reitermodulSelector);
        createTabs();
        hideTabBody($(getSelectorFromClass(tabClass)).not(getSelectorFromClass(tabIsOpenClass)));
        $(getSelectorFromClass(reiterHeadClass)).hide();
        addClickHandler();
        if (Configuration_1.configuration.reitermodulBreakpoint === "phone/tablet") {
            client_detection_1.MobileDetection.matchMediaMobile(matchMediaListener);
        }
        else {
            client_detection_1.MobileDetection.matchMediaTabletOrSmaller(matchMediaListener);
        }
    }
    exports.initialize = initialize;
    $(function () {
        initialize();
    });
});
